<template>
 
  <div class="">
    <!-- ======================== Sambutan ========================  -->
    <div class="q-my-xxs q-py-xl q-px-xl bg-gray-3" v-if="$q.screen.lt.sm">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Data Indeks Kepuasan Masyarakat</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Data Indeks Kepuasan Masyarakat</span></div>
      </div>
    </div>

    <div class="q-my-xxs q-py-xl q-px-xl text-center bg-grey-3" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Data Indeks Kepuasan Masyarakat</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Data Indeks Kepuasan Masyarakat</span></div>
      </div>
    </div>

    <div class="row wrap justify-between items-start content-start ">
      <!-- <div class="q-pa-xl row q-col-gutter-lg"> -->
      <!-- <div class="col-12 col-md-12 col-sm-12 col-xs-12 q-pa-md q-gutter-y-lg items-end">
      <div class="col-12 q-pa-lg" id="haki">
      </div>
      </div> -->
      <div class="col-12 col-md-12 col-sm-12 col-xs-12 q-pa-md q-gutter-y-lg items-end">
            <div class="col-12 q-pa-lg">
                <q-input standout="bg-secondary text-black" bottom-slots v-model="cari_value" @keyup="cari_data()" label="Pencarian" style="width:100%" >
                    <template v-slot:prepend>
                        <q-icon color="black" name="search" />
                    </template>
                </q-input>
            </div>
        
        <div class="col-12 q-pa-lg">
          <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_head bg-teal-2">
                <th width="2%" class="text-center">No</th>
                <th width="10%">Responden</th>
                <th width="10%">Email</th>
                <th width="10%">Umur</th>
                <th width="10%">Pendidikan</th>
                <th width="10%">Pekerjaan</th>
                <th width="5%">#</th>
              </tr>
              <tr class="h_table_body" v-for="(data, index ) in list_data" :key="data.id">
                <td class="text-center">{{index+1}}</td>
                <td >
                    {{data.nama}}
                </td>
                <td >
                    {{data.email}}
                </td>
                <td >
                    {{data.umur}}
                </td>
                <td >
                    {{data.pendidikan}}
                </td>
                <td >
                    {{data.pekerjaan}}
                </td>
                <td class="text-center">
                  <q-btn round color="secondary" icon="description" @click="persistent = true, selectData(data)">
                    <q-tooltip class="bg-secondary">Lihat Survey</q-tooltip>
                    </q-btn>
                </td>
              </tr>

            </table>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        </div>

          <div class="q-pa-lg flex flex-center">
            <q-btn @click="btn_prev" color="secondary" icon="mdi-skip-previous" />
            &nbsp;
            <span style="font-size: 85%; color: #a5a5a5">
                <b>{{page_first}} - {{page_last}}</b>
            </span>
            &nbsp;
            <q-btn @click="btn_next" color="secondary" icon="mdi-skip-next" />   
          </div>
      </div>
    </div>

    <q-dialog v-model="persistent" persistent full-width transition-show="scale" transition-hide="scale">
      <q-card class="text-white mdl-md">
        <q-card-section class="bg-teal">
          <div class="text-h6">Data Survey</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
            <br>
                        <div class="modal-body">
            <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_body">
                <td >Bagaimana Pendapat Bapak/Ibu/Saudara (i) tentang kesesuaian persyaratan pelayanan dengan jenis pelayanannya pada BRIDA KONSEL ?</td>
                <td >{{form.persyaratan}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana menurut Bapak/Ibu/Saudara (i) tentang kemudahan prosedur/ mekanisme pelayanan yang diberikan  pada BRIDA KONSEL ?</td>
                <td >{{form.prosedur}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana pendapat  Bapak/Ibu/Saudara (i) tentang kecepatan pelayanan yang diberikan  pada BRIDA KONSEL ?</td>
                <td >{{form.pelayanan}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana  menurut Bapak/Ibu/Saudara (i)  dalam hal Biaya/Tarif Pelayanan  pada BRIDA KONSEL, apakah sudah sesuai dengan biaya yang di tetapkan ?</td>
                <td >{{form.tarif}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana menurut Bapak/Ibu/Saudara (i)  kesesuaian antara hasil pelayanan yang di berikan  BRIDA KONSEL dengan ketentuan yang di tetapkan / permintaan awal ?</td>
                <td >{{form.ketentuan}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaiman menurut Bapak/Ibu/Saudara (i) kemampuan/Kompetensi petugas pelayanan BRIDA KONSEL dalam hal memberikan pelayanan ?</td>
                <td >{{form.kompetensi}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana pendapat  Bapak/Ibu/Saudara (i) tentang sikap, tingkah laku (kesopanan dan keramahan) petugas pelayanan BRIDA KONSEL dalam memberikan pelayanan ?</td>
                <td >{{form.sikap}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana menurut Bapak/Ibu/Saudara (i) kesesuaian antara Pelayanan yang di dapat dengan Hasil Maklumat Pelayanan (Standar Pelayanan) yang di tetapkan pada BRIDA KONSEL ?</td>
                <td >{{form.maklumat}}</td>
              </tr>
              <tr class="h_table_body">
                <td >Bagaimana pendapat Bapak/Ibu/Saudara (i)  mengenai kemudahan menyampaikan pengaduan, saran dan masukan di BRIDA KONSEL ?</td>
                <td >{{form.pengaduan}}</td>
              </tr>

            </table>
            </div>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="Tutup" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>     
</template>

<script>
export default {
  name: 'inotek',
  data() {
         return {
      data_load: false,
      form : {
                id : '',
                    nama : '',
                    umur : '',
                    email : '',
                    umur : '',
                    pendidikan : '',
                    pekerjaan : '',
                    persyaratan : '',
                    prosedur : '',
                    pelayanan : '',
                    tarif : '',
                    ketentuan : '',
                    kompetensi : '',
                    sikap : '',
                    maklumat : '',
                    pengaduan : '',
                    createAt : '',
            },
      persistent : false,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
    },
    methods: {

    getView: function () {
      fetch(this.$store.state.URL_MANIS + "ikm", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          console.log(res_data);
        });
    },

    selectData : function(data){
        this.form.id = data.id
        this.form.nama = data.nama
        this.form.email = data.email
        this.form.umur = data.umur
        this.form.nama = data.nama
        this.form.pendidikan = data.pendidikan
        this.form.pekerjaan = data.pekerjaan
        this.form.persyaratan = data.persyaratan
        this.form.prosedur = data.prosedur
        this.form.pelayanan = data.pelayanan
        this.form.tarif = data.tarif
        this.form.ketentuan = data.ketentuan
        this.form.kompetensi = data.kompetensi
        this.form.sikap = data.sikap
        this.form.maklumat = data.maklumat
        this.form.pengaduan = data.pengaduan
        this.form.createAt = data.createAt
    },

    // ================== PAGINASI ====================
    alertku: function (type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800,
      });
    },

    btn_prev: function () {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.getView();
  },

}
</script>
